export default {
  list: { lazy: () => import('./otherComponents'), component: 'ComponentOtherList' },
  edit: { lazy: () => import('./otherComponents'), component: 'ComponentOtherEdit' },
  create: { lazy: () => import('./otherComponents'), component: 'ComponentOtherCreate' },
}
